import { render } from "./KSB.vue?vue&type=template&id=530a27b4"
import script from "./KSB.vue?vue&type=script&lang=js"
export * from "./KSB.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__